import { z } from 'zod'

export const zProductPartStatusEnum = z.enum(['A', 'O', 'P', 'D', 'S', 'T', 'N', 'UNKNOWN'])

export type ProductPartStatusEnumSchema = z.infer<typeof zProductPartStatusEnum>

export const ProductPartStatusEnum = zProductPartStatusEnum.enum
